"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "agazzano": {
    "9bd53db7": [{
      "hkey": "40009b6c",
      "slug": "agazzano",
      "name": "Agazzano",
      "primary": true,
      "skipSearch": false
    }],
    "boffalora": [{
      "hkey": "40009b6c",
      "slug": "agazzano",
      "name": "Agazzano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "044d9c60": [{
      "hkey": "40009b6c",
      "slug": "agazzano",
      "name": "Agazzano",
      "primary": true,
      "skipSearch": false
    }],
    "cantone": [{
      "hkey": "40009b6c",
      "slug": "agazzano",
      "name": "Agazzano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "40561571": [{
      "hkey": "40009b6c",
      "slug": "agazzano",
      "name": "Agazzano",
      "primary": true,
      "skipSearch": false
    }],
    "grintorto": [{
      "hkey": "40009b6c",
      "slug": "agazzano",
      "name": "Agazzano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c1e5b3a8": [{
      "hkey": "810572fe",
      "slug": "tavernago",
      "name": "Tavernago",
      "primary": true,
      "skipSearch": false
    }],
    "tavernago-verdeto": [{
      "hkey": "810572fe",
      "slug": "tavernago",
      "name": "Tavernago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;